import { Typography, Box } from "@mui/material";
import "./styles.css";

const StudentCohortCard = ({ icon, value, label }) => {
  return (
    <Box className="student-cohort-card">
      <Box className="student-cohort-card-container">
        <Box>
          <img src={icon} className="student-cohort-card-img" alt="icon-img" />
          <Typography className="student-cohort-card-value">{value}</Typography>
        </Box>
      </Box>
      <Typography className="student-cohort-card-label">{label}</Typography>
    </Box>
  );
};

export default StudentCohortCard;
